/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type V1ApiKeysListKeysResponseData = {
  /**
   * Stable API key identifier.
   */
  keyId: string;
  /**
   * User-supplied name, or null when absent.
   */
  name: string | null;
  /**
   * Stored display fragment, including the prefix when present.
   */
  start: string;
  /**
   * Stored trailing display fragment. Empty for keys without a recorded suffix.
   */
  end: string;
  /**
   * Whether the key is administratively enabled. An enabled key can still be expired.
   */
  enabled: boolean;
  /**
   * Creation time in Unix milliseconds.
   */
  createdAt: number;
  /**
   * Last verification time in Unix milliseconds. Zero means the API key has not been used.
   */
  lastUsedAt: number;
  /**
   * Expiration time in Unix milliseconds, or null for no expiration.
   */
  expires: number | null;
  /**
   * All permissions assigned to the API key.
   */
  permissions: Array<string>;
};

/** @internal */
export const V1ApiKeysListKeysResponseData$inboundSchema: z.ZodType<
  V1ApiKeysListKeysResponseData,
  z.ZodTypeDef,
  unknown
> = z.object({
  keyId: z.string(),
  name: z.nullable(z.string()),
  start: z.string(),
  end: z.string(),
  enabled: z.boolean(),
  createdAt: z.number().int(),
  lastUsedAt: z.number().int(),
  expires: z.nullable(z.number().int()),
  permissions: z.array(z.string()),
});

export function v1ApiKeysListKeysResponseDataFromJSON(
  jsonString: string,
): SafeParseResult<V1ApiKeysListKeysResponseData, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => V1ApiKeysListKeysResponseData$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'V1ApiKeysListKeysResponseData' from JSON`,
  );
}
